import { useNavigate } from 'react-router-dom';

const useIntroController = () => {
  const navigate = useNavigate();

  const redirectToClinic = () => {
    navigate('./clinic');
  };

  return {
    redirectToClinic,
  };
};

export default useIntroController;
